import React from 'react';
import './OperationModal.css';

const OperationModal = ({ operation, onClose }) => {
    if (!operation) return null;

    const getStatusInfo = (status) => {
        const statusNumber = Number(status);
        switch (statusNumber) {
            case 1: return { text: 'Выполнено', class: 'status-1' };
            case 2: return { text: 'В ожидании', class: 'status-2' };
            case 3: return { text: 'В процессе', class: 'status-3' };
            case 4: return { text: 'Ошибка', class: 'status-4' };
            case 5: return { text: 'На паузе', class: 'status-5' };
            case 6: return { text: 'Планируется', class: 'status-6' };
            case 7: return { text: 'Отменено', class: 'status-7' };
            default: return { text: 'Неизвестно', class: 'status-2' };
        }
    };

    const statusInfo = getStatusInfo(operation.status);

    return (
        <div className="operation-modal-overlay" onClick={onClose}>
            <div className="operation-modal" onClick={e => e.stopPropagation()}>
                <div className="operation-modal-header">
                    <h2>Детали операции</h2>
                    <div className="operation-modal-subtitle">
                        Информация о выбранной операции
                    </div>
                    <button
                        className="operation-modal-close-btn"
                        onClick={onClose}
                        title="Закрыть"
                    >
                        ✕
                    </button>
                </div>

                <div className="operation-modal-content">
                    <div className="operation-info-grid">
                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                📌 Основная информация
                            </div>
                            <div className="operation-info-value">
                                {operation.title || operation.operationNumber || 'Операция без названия'}
                            </div>
                        </div>

                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                🔢 ID операции
                            </div>
                            <div className="operation-info-value">
                                {operation.id || 'Не указан'}
                            </div>
                        </div>

                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                📅 Дата начала
                            </div>
                            <div className="operation-info-value">
                                {operation.startDate ? new Date(operation.startDate).toLocaleString('ru-RU', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                }) : 'Не указана'}
                            </div>
                        </div>

                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                📅 Дата окончания
                            </div>
                            <div className="operation-info-value">
                                {operation.endDate ? new Date(operation.endDate).toLocaleString('ru-RU', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                }) : 'Не указана'}
                            </div>
                        </div>

                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                🕐 Длительность
                            </div>
                            <div className="operation-info-value">
                                {operation.startDate && operation.endDate ?
                                    `${Math.ceil((new Date(operation.endDate) - new Date(operation.startDate)) / (1000 * 60 * 60 * 24))} дней` :
                                    'Не указана'}
                            </div>
                        </div>

                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                🏷️ Статус
                            </div>
                            <div className={`operation-info-value operation-status ${statusInfo.class}`}>
                                {statusInfo.text}
                            </div>
                        </div>
                    </div>

                    {operation.resourceId && (
                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                👥 Ресурс
                            </div>
                            <div className="operation-info-value">
                                ID ресурса: {operation.resourceId}
                            </div>
                        </div>
                    )}

                    {operation.operationId && (
                        <div className="operation-info-card">
                            <div className="operation-info-title">
                                🔧 Дополнительно
                            </div>
                            <div className="operation-info-value">
                                Операция #{operation.operationId}
                                {operation.operationNumber && ` • Номер: ${operation.operationNumber}`}
                            </div>
                        </div>
                    )}

                    <div className="operation-timeline">
                        <div className="timeline-title">Таймлайн</div>
                        <div className="timeline-item">
                            <div className="timeline-icon">🕐</div>
                            <div className="timeline-content">
                                <div className="timeline-label">Начало операции</div>
                                <div className="timeline-value">
                                    {operation.startDate ? new Date(operation.startDate).toLocaleString() : 'Не указано'}
                                </div>
                            </div>
                        </div>
                        <div className="timeline-item">
                            <div className="timeline-icon">✅</div>
                            <div className="timeline-content">
                                <div className="timeline-label">Окончание операции</div>
                                <div className="timeline-value">
                                    {operation.endDate ? new Date(operation.endDate).toLocaleString() : 'Не указано'}
                                </div>
                            </div>
                        </div>
                        <div className="timeline-item">
                            <div className="timeline-icon">📊</div>
                            <div className="timeline-content">
                                <div className="timeline-label">Прогресс</div>
                                <div className="timeline-value">
                                    {operation.status === '1' ? '100% завершено' :
                                        operation.status === '3' ? 'В процессе выполнения' :
                                            'Ожидает начала'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="operation-actions">
                        <button
                            className="operation-action-btn primary"
                            onClick={() => {
                                console.log('Действие для операции:', operation);
                                // Здесь можно добавить логику
                            }}
                        >
                            📋 Детальный отчет
                        </button>
                        <button
                            className="operation-action-btn secondary"
                            onClick={onClose}
                        >
                            ✕ Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OperationModal;